<template>
    <div>
        <q-dialog
            v-model="modal"
            transition-show="scale"
            transition-hide="scale"
            :maximized="$q.platform.is.mobile">
            <q-card class="modal-testimonial modal-store-testimonial">
                <div class="modal-header">
                    <span class="modal-title">Отзыв о магазине</span>
                    <div class="modal-close" @click="modal=false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px" width="10px"
                                 height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                <path d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <q-input
                        square
                        outlined
                        v-model="form.name"
                        @input="form.errors.clear('name')"
                        :error-message="form.errors.get('name')"
                        :error="form.errors.has('name')"
                        label="Ваше имя"
                        class="q-pt-md"/>
                    <q-input
                        square
                        outlined
                        v-model="form.city"
                        @input="form.errors.clear('city')"
                        :error-message="form.errors.get('city')"
                        :error="form.errors.has('city')"
                        label="Ваш город">

                        <template v-slot:prepend>
                            <q-avatar>
                                <span @click.prevent="$root.selectCity()">
                                    <q-icon name="place" />
                                </span>
                            </q-avatar>
                        </template>
                    </q-input>
                    <div class="testimonial-rating">
                        <div class="testimonial-rating-item">
                            <span>Товар</span>
                            <q-rating
                                class=""
                                v-model="form.product_rate"
                                size="3.5em"
                                color="primary"
                                @input="form.errors.clear('product_rate')"
                                :class="{ 'has-error': form.errors.has('product_rate') }"
                            ></q-rating>
                            <div v-if="form.errors.has('product_rate')" class="text-negative">
                                {{ form.errors.get('product_rate') }}
                            </div>
                        </div>
                        <div class="testimonial-rating-item">
                            <span>Сервис</span>
                            <q-rating
                                v-model="form.service_rate"
                                size="3.5em"
                                color="primary"
                                @input="form.errors.clear('service_rate')"
                                :class="{ 'has-error': form.errors.has('service_rate') }"
                            ></q-rating>
                            <div v-if="form.errors.has('service_rate')" class="text-negative">
                                {{ form.errors.get('service_rate') }}
                            </div>
                        </div>
                        <div class="testimonial-rating-item">
                            <span>Доставка</span>
                            <q-rating
                                v-model="form.delivery_rate"
                                size="3.5em"
                                color="primary"
                                @input="form.errors.clear('delivery_rate')"
                                :class="{ 'has-error': form.errors.has('delivery_rate') }"
                            ></q-rating>
                            <div v-if="form.errors.has('delivery_rate')" class="text-negative">
                                {{ form.errors.get('delivery_rate') }}
                            </div>
                        </div>
                    </div>
                    <q-input
                        outlined
                        label="Ваш отзыв"
                        v-model="form.message"
                        type="textarea"
                        @input="form.errors.clear('message')"
                        :error-message="form.errors.get('message')"
                        :error="form.errors.has('message')"
                    />

                    <q-card-actions align="right" class="q-pa-none">
                        <q-btn outlined color="primary" label="Оставить отзыв" @click.prevent="submitFeedback" />
                    </q-card-actions>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="alert" persistent transition-show="scale" transition-hide="scale">
            <q-card class="modal-testimonial-done">
                <div class="modal-close" @click="alert=false">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             x="0px" y="0px" width="10px"
                             height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
                <q-card-section class="modal-content">
                    <span class="text">
                        {{ responseMessage }}
                    </span>
                    <q-card-actions align="center" class="q-pa-none">
                        <q-btn square outlined color="primary" label="Хорошо" @click.prevent="close()"/>
                    </q-card-actions>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex';
    import {Form} from "../../classes/Form";

    export default {
        name: 'Feedback',
        data () {
            return {
                form: new Form({
                    name: '',
                    city: '',
                    message: '',
                    product_rate: 0,
                    service_rate: 0,
                    delivery_rate: 0,
                }),
                alert: false,
                responseMessage: '',
            }
        },
        mounted() {
            let account = this.$root.account();

            if (account) {
                this.form.name = account.first_name;
            }
        },
        watch: {
            '$root.cityName' (newVal, oldVal) {
                if (newVal) {
                    this.form.city = newVal;
                }
            }
        },
        methods: {
            ...mapMutations('feedback', [
                'hideModal',
            ]),

            submitFeedback () {
                let _this = this;
                _this.submit();
            },

            submit () {
                let _this = this;

                _this.form.post('/feedback')
                    .then(response => {
                        if (response.status === 'success') {

                            _this.form.reset();

                            this.responseMessage = response.message;
                            this.modal = false;
                            this.alert = true;
                        }
                    })
                    .catch(error => {});
            },

            close () {
                this.alert = false;
                this.responseMessage = '';

                this.hideModal();
                this.form.reset();
            },
        },
        computed: {
            modal: {
                get () {
                    return this.$store.state.feedback.modal;
                },
                set (value) {
                    this.hideModal();
                }
            },
        }
    }
</script>
